import { v3dMaterial, v3dMesh } from '@/Interfaces/common';
import { IV3D } from '@/Interfaces/v3d';
declare let v3d: IV3D;
export default function changeColor(material: v3dMaterial, node: string, hexColor: string) {
    if (!material) return;
    if (!material.nodeRGBMap) return;
    const RgbExternalIndex = material?.nodeRGBMap[node];
    // console.log('material', material, material?.nodeRGBMap[node]);
    if (typeof RgbExternalIndex === 'undefined') return;
    const color = new v3d.Color(hexColor);
    // color.convertSRGBToLinear();

    // @ts-ignore
    material.nodeRGB[RgbExternalIndex] = new v3d.Vector4(color.r, color.g, color.b, 1);
    material.needsUpdate = true;
}
